<template>
  <GlobalAlertWindow
    v-loading="isUploading"
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="120px" label-suffix="："  inline>
      <div class="tips-style">您真在针对订单：<span>{{ form.code }} </span>进行发货</div>
      <el-form-item label="快递公司" prop="kdId">
        <el-select
          v-model="form.kdId"
          filterable
          clearable
          placeholder="请选择快递公司"
        >
          <el-option v-for="item in kd" :key="item.id" :value="item.id" :label="item.label" />
        </el-select>
      </el-form-item>
      <el-form-item label="快递单号" prop="kdCode">
        <el-input v-model="form.kdCode" placeholder="请输入快递单号" :maxlength="5" v-trim/>
      </el-form-item>
      <el-form-item label="发货备注" prop="kdInfo">
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 12}" v-model="form.kdInfo" placeholder="请输入发货备注" :maxlength="5" v-trim/>
      </el-form-item>
      
    </el-form>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
import { fetchList as kdList } from '@/api/business/labels'
export default {
  name: 'OperaShipmentsWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow },
  data () {
    return {
      isUploading: false,
      // 表单数据
      form: {
        id: null,
        code: '',
        kdId: '',
        kdInfo: '',
        kdCode: '',
        // isdeleted: '',
        // name: '',
        // info: '',
        // type: '',
        // module: '',
        // parentId: '',
        // sortnum: '',
        // status: '',
        // imgurl: ''
      },
      kd: [],
      // 验证规则
      rules: {
        kdId: [
          { required: true, message: '请选择快递公司', tigger: 'change' }
        ],
        kdCode: [
          { required: true, message: '请输入快递单号', tigger: 'blur' }
        ]
      }
    }
  },
  
  created () {
    this.config({
      api: '/business/labels',
      'field.id': 'id'
    })
  },
  mounted() {
    kdList({
      capacity: 999,
      model: {
        type: 3 //快递
      }
    })
      .then(res => {
        this.kd = res.records
      })
  },
  methods: {
    // 上传图片
    uploadAvatarSuccess(file) {
      this.form.imgurl = file.imgurl;
      this.form.imgurlfull = file.imgurlfull;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";

.tips-style {
  font-size: 16px;
  span {
    font-weight: 500;
  }
  margin-bottom: 10px;
}

::v-deep .el-select {
  width: 100%;
  .el-input__inner {
    width: 100%;
  }
}

</style>
